import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";
import userSlice from "src/store/userSlice";
import layoutSlice from "src/store/layoutSlice";
import dataSlice from "src/store/dataSlice";
import createInspectionTemplateSlice from "src/store/createInspectionTemplateSlice";

export const reducers = {
  user: userSlice,
  layout: layoutSlice,
  data: dataSlice,
  createInspectionTemplate: createInspectionTemplateSlice,
};

const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // to allow non serializable objects to be stored in redux (eg: Map, Set, classes etc.)
    }),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
